export default {
  props: ['human', 'text', 'img', 'popup'],
  computed: {
    imgDynamic () {
      return /^http/.test(this.img) ? this.img : require('../../../img' + this.img)
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/game/msg/msg.js